// Supported filter types used across CustomFilters components
export enum FilterType {
  Input = 'input',
  Date = 'date',
  DateTime = 'datetime',
  Time = 'time',
  Select = 'select',
  Search = 'search',
  Radio = 'radio',
  Checkbox = 'checkbox',
  SliderRange = 'slider_range',
  InputNumber = 'inputnumber',
}

// Helper set for multi-select type checks
export const MULTI_SELECT_TYPES: ReadonlySet<string> = new Set([
  FilterType.Select,
  FilterType.Search,
  FilterType.Radio,
  FilterType.Checkbox,
]);

